import React, { ReactElement } from 'react';

import './AppSwitcherButton.scss';

export const AppSwitcherButton = ({
  label,
  icon,
  onClick,
  gtm = 'app-switcher-button',
}: {
  label: string;
  icon: ReactElement;
  onClick(): void;
  gtm?: string;
}) => {
  return (
    <div
      className="app-switcher-button"
      role="button"
      tabIndex={0}
      data-gtm={gtm}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClick();
        }
      }}
    >
      <div className="app-switcher-button__icon-container">{icon}</div>
      <p className="app-switcher-button__label">{label}</p>
    </div>
  );
};
